import { SelectedMenu } from 'rangeConfig/@types';
import { CoreApi, ProductType } from '@inter-ikea-storageone/range';
import deleteLights from 'rangeConfig/pax/behaviors/deleteLights';
import autoFillLights from 'rangeConfig/pax/behaviors/autoFillLights';
import { getIsInnerLight, getIsOuterLight } from 'rangeConfig/pax/utils/utils';
import { matchLightWidth } from 'rangeConfig/pax/filters/selectedMenuProductFilters';
import LightsOptions from 'rangeConfig/pax/widgets/lightsOptions/LightsOptions';

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListChangeLights',
  behaviors: {
    productDeleted: [deleteLights]
  },
  content: [
    { id: 'lights-options', component: LightsOptions },
    {
      id: 'lights-selected-menu-outer-lights',
      title: 'storageone.productListOuterLights',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText',
      additionalItemsText: 'storageone.selectedProductAdditionalOuterLights',
      behaviors: {
        productClicked: [autoFillLights],
        productDropped: [autoFillLights]
      },
      productTypes: [ProductType.PAX_OUTER_LIGHT],
      hidden: (coreApi: CoreApi, selectedEntityId: number) =>
        !getIsOuterLight(coreApi, selectedEntityId),
      noThumbs: () => true,
      productFilters: [],
      useMLSorting: true
    },
    {
      id: 'lights-selected-menu-inner-lights',
      title: 'storageone.productListInnerLights',
      cardsTitle: 'name',
      cardsSubtitle: 'typeName, designText',
      additionalItemsText: 'storageone.selectedProductAdditionalInnerLights',
      behaviors: {
        productClicked: [autoFillLights],
        productDropped: [autoFillLights]
      },
      productTypes: [ProductType.PAX_INNER_LIGHT, ProductType.PAX_INNER_LIGHT_OVERSIDAN],
      hidden: (coreApi: CoreApi, selectedEntityId: number) =>
        !getIsInnerLight(coreApi, selectedEntityId),
      noThumbs: () => true,
      productFilters: [matchLightWidth],
      useMLSorting: true
    }
  ]
};

export default selectedMenu;
